import script from "./CommunityVoice.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityVoice.vue?vue&type=script&setup=true&lang=js"

import "./CommunityVoice.vue?vue&type=style&index=0&id=1d7332c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7332c3"]])

export default __exports__